export enum DictionaryType {
  COUNTRIES,
  COUNTRIES_USED,
  OBSERVATION_TYPES,
  KEYWORDS,
  KEYWORDS_USED,
  PROPERTIES,
  SOURCES,
}
